export default __webpack_public_path__ + "static/media/bulgeria.db729dc7.png";